import { FONT_MAX, LINE_HEIGHT_HEADING } from '../themeConstants'

const displayHeading = {
  fontFamily: 'var(--app-font-display)',
  fontSize: FONT_MAX,
  lineHeight: LINE_HEIGHT_HEADING,
}

export const typographyHeadings = {
  h1: { ...displayHeading, fontWeight: 700 },
  h2: { ...displayHeading, fontWeight: 700 },
  h3: { ...displayHeading, fontWeight: 700 },
  h4: { ...displayHeading, fontWeight: 600 },
  h5: { ...displayHeading, fontWeight: 600 },
  h6: { ...displayHeading, fontWeight: 600 },
}
